// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".searchQuery {\n  width: 320px;\n  border-radius: 0.3em;\n  -webkit-transition: background-color 200ms ease;\n  transition: background-color 200ms ease;\n}\n.searchQuery--hasValue {\n  background-color: rgba(0, 0, 0, 0.3);\n}\n.searchQuery--wide {\n  width: 400px;\n}\n.searchQuery .v-input__slot {\n  margin: 0;\n  color: white;\n}\n.searchQuery .v-messages__message {\n  margin: 4px 0;\n}", ""]);
// Exports
module.exports = exports;
